// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon--btDrp{flex-shrink:0;width:22px;height:22px;color:currentColor}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/Nav/index.module.scss"],"names":[],"mappings":"AAAA,aAAM,aAAa,CAAC,UAAU,CAAC,WAAW,CAAC,kBAAkB","sourcesContent":[".icon{flex-shrink:0;width:22px;height:22px;color:currentColor}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "icon--btDrp"
};
export default ___CSS_LOADER_EXPORT___;
